import React, { useEffect, useRef, useState } from "react";
import "./DropdownPortal.scss";

import Dropdown from "rc-dropdown";
import "rc-dropdown/assets/index.css";
import { overlaysRef } from "src/App";
import { DROPDOWN_OPEN_EVENT } from "src/utils/dropdownEvents";
import zIndex from "src/utils/zIndex";

export function DropdownPortal({
  trigger = ["click"],
  placement = "bottomLeft",
  disabled = false,
  disableGlobalCloseEvent = false,
  ...rest
}) {
  const dropdownIdRef = useRef(Math.random().toString(36).slice(2));
  const onVisibleChange = rest.onVisibleChange;
  const isControlled = rest.visible !== undefined;
  const [internalVisible, setInternalVisible] = useState(false);
  const visible = isControlled ? rest.visible : internalVisible;
  const visibleRef = useRef(visible);

  useEffect(() => {
    visibleRef.current = visible;
  }, [visible]);

  useEffect(() => {
    if (disableGlobalCloseEvent) return;

    const handleOtherDropdownOpen = (event) => {
      if (event.detail?.id === dropdownIdRef.current || !visibleRef.current) {
        return;
      }

      if (!isControlled) {
        setInternalVisible(false);
      }

      onVisibleChange?.(false);
    };

    window.addEventListener(DROPDOWN_OPEN_EVENT, handleOtherDropdownOpen);

    return () => {
      window.removeEventListener(DROPDOWN_OPEN_EVENT, handleOtherDropdownOpen);
    };
  }, [disableGlobalCloseEvent, isControlled, onVisibleChange]);

  const handleVisibleChange = (nextVisible) => {
    if (!isControlled) {
      setInternalVisible(nextVisible);
    }

    if (nextVisible && !disableGlobalCloseEvent) {
      window.dispatchEvent(
        new CustomEvent(DROPDOWN_OPEN_EVENT, {
          detail: { id: dropdownIdRef.current },
        }),
      );
    }

    onVisibleChange?.(nextVisible);
  };

  return (
    <Dropdown
      {...rest}
      trigger={disabled ? ["none"] : trigger}
      overlayStyle={{ zIndex: zIndex.dropdown, paddingTop: "10px" }}
      placement={placement}
      getPopupContainer={() => overlaysRef.current}
      onVisibleChange={handleVisibleChange}
      visible={visible}
      ref={rest?.ddRef}
      destroyPopupOnHide
    />
  );
}
